(() => {
  const wrapper = document.getElementById('GlobalTransitionWrapper');

  if (!wrapper) return;

  // Global Page Transition
  // Fade in on load
  window.addEventListener('pageshow', (event) => {
    // If it's a back/forward navigation, ensure it's visible
    if (event.persisted) {
      document.body.classList.remove('page-transitioning');
      document.body.classList.add('page-loaded');
    } else {
      // Normal load
      requestAnimationFrame(() => {
        document.body.classList.add('page-loaded');
      });
    }
  });

  // Intercept internal links
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented) return;

    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    // Ignore external links, anchors, mailto, etc.
    if (
      link.hostname !== window.location.hostname ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      link.target === '_blank' ||
      e.ctrlKey || e.metaKey || e.shiftKey
    ) {
      return;
    }

    // Ignore cart links so the cart drawer can handle them
    const cartUrl = window.routes ? window.routes.cart_url : '/cart';
    let pathname = link.pathname;
    if (!pathname.startsWith('/')) pathname = '/' + pathname;
    pathname = pathname.replace(/\/$/, '');
    const targetUrl = cartUrl.replace(/\/$/, '');
    if (pathname === targetUrl || pathname === '/cart') {
      return;
    }

    e.preventDefault();
    
    document.body.classList.remove('page-loaded');
    document.body.classList.add('page-transitioning');

    setTimeout(() => {
      window.location.href = href;
    }, 200); // 200ms transition
  });
})();